// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"426":"8240bbfa72bf64ee","888":"e6ad85a4a2db7b86"}[chunkId] + ".css";
};